export default __webpack_public_path__ + "assets/spinner-verified.gif?0cde0599b29e08ac4328c5fdec983f27";